import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as Logo } from 'assets/images/authenticate-logo.svg';

const AuthenticateLogo = ({ style = {} }) => (
    <Logo style={{ height: '12px', width: 'auto', marginTop: '-4px', ...style }} />
);

AuthenticateLogo.propTypes = {
    style: PropTypes.object,
};

export default AuthenticateLogo;
